import { Dialog, DialogContent } from '@mui/material'
import { UpTransition } from '../animations'
import { Button } from '../buttons'
import PatientInvoicesQuickPay from '../tables/PatientInvoicesQuickPay'

interface Props {
  quickPayOpen: boolean
  setQuickPayOpen: (open: boolean) => void
  quickPayPatientId: number | null
  onPaymentComplete?: (orderId: number | null) => void
}

const UnpaidPatientInvoicesDialog = ({
  quickPayOpen,
  setQuickPayOpen,
  quickPayPatientId,
  onPaymentComplete,
}: Props) => {
  return (
    <Dialog
      open={quickPayOpen}
      onClose={() => setQuickPayOpen(false)}
      TransitionComponent={UpTransition}
      fullScreen
    >
      <DialogContent sx={{ p: 0 }}>
        <div className="flex justify-end p-2">
          <Button
            variant="outlined"
            onClick={() => setQuickPayOpen(false)}
            text="Fermer"
          />
        </div>
        {quickPayPatientId != null && (
          <PatientInvoicesQuickPay
            patientId={quickPayPatientId}
            onPaymentComplete={
              onPaymentComplete
                ? (orderId) => {
                    setQuickPayOpen(false)
                    onPaymentComplete(orderId)
                  }
                : undefined
            }
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default UnpaidPatientInvoicesDialog
